import React, { Fragment, useState,useEffect } from "react";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
import ChatBox from "../ChatBox";

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const [employee,setEmployee]=useState('')
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  useEffect(()=>{
    const getEmployeeData = () => {
      const data = localStorage.getItem("employee");
      return data ? JSON.parse(data) : null;
    };
    const employee = getEmployeeData();
    setEmployee(employee); 

    
  },[])
  return (
    <Fragment>
      <NavHader employee={employee} />
      <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />
      <Header
        onNote={() => onClick("chatbox")}
        onNotification={() => onClick("notification")}
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
        employee={employee}
      />
      <SideBar employee={employee} />
    </Fragment>
  );
};

export default JobieNav;
